import FleetTitle from '@/libs/antd/components/Title';
import { Button, Row, Space, Table } from 'antd';
import { FilePdfOutlined, FileSearchOutlined } from '@ant-design/icons';
import { FC } from 'react';
import CallReportAttendeeModal, {
	useCallReportAttendeeModal,
} from './CallReportAttendeeModal';
import { useApp } from '@/App';
import { useQuery } from '@tanstack/react-query';
import { getFRMCallReportHistories } from '@/libs/fleet-api/services/visit-reports';
import dayjs from 'dayjs';
import { useModals } from '@/components/modals/ModalProvider';

const FRMCallReportHistoryPage: FC<{ prospectId: string }> = ({
	prospectId,
}) => {
	const { navigate } = useApp();
	const { openPreviewModal, openCallReportPDFModal } = useModals();
	const { data, isFetching } = useQuery({
		queryKey: ['getFRMCallReportList', prospectId] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id) return null;
			return getFRMCallReportHistories(id);
		},
	});

	const callReportAttendeeModal = useCallReportAttendeeModal();

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<FleetTitle>Historical Call Report</FleetTitle>

			<Row style={{ display: 'flex', justifyContent: 'end' }}>
				<Button
					style={{
						color: '#1557BC',
						borderRadius: 50,
						fontSize: 12,
						height: 24,
						borderColor: '#1557BC',
						fontWeight: 700,
						marginBottom: 20,
					}}
					icon={'+'}
					onClick={() => {
						navigate('FRMCallReportPage', {
							prospectId,
							redirect: 'FRMCallReportListPage',
						});
					}}
				>
					Add Another
				</Button>
			</Row>

			<Table
				bordered
				scroll={{ x: 'max-content' }}
				pagination={false}
				loading={isFetching}
				dataSource={
					data?.data.surveyCallReports?.map((data, key) => {
						return {
							...data,
							key,
						};
					}) ?? []
				}
				columns={[
					{
						title: 'No',
						width: 1,
						align: 'center',
						render: (_, __, i) => i + 1,
					},
					{
						title: 'Prospect ID',
						render: (_, record) => record.prospectId,
					},
					{
						title: 'Nama Customer',
						render: (_, record) => {
							if (!record.customerName) return '-';
							return (
								<a
									href="#"
									onClick={(e) => e.preventDefault()}
								>
									{record.customerName}
								</a>
							);
						},
					},
					{
						title: 'Tanggal Konfirmasi',
						render: (_, record) =>
							dayjs(record.confirmationDate).format('DD/MM/YYYY'),
					},
					{
						title: 'Media Konfirmasi',
						render: (_, record) => record.confirmationMedia?.value ?? '-',
					},
					{
						title: 'Pihak Yang Hadir',
						align: 'center',
						render: (_, record) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										callReportAttendeeModal.open(record.contacts);
									}}
								>
									<FileSearchOutlined />
								</a>
							);
						},
					},
					{
						title: 'Poin Konfirmasi',
						render: (_, record) =>
							record.confirmations?.[0]?.confirmationPoint ?? '-',
					},
					{
						title: 'Detail Konfirmasi',
						render: (_, record) =>
							record.confirmations?.[0]?.confirmationDetail ?? '-',
					},
					{
						title: 'Evidence',
						align: 'center',
						render: (_, record) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										if (!record.evidenceFile) return;
										openPreviewModal(record.evidenceFile);
									}}
								>
									<FileSearchOutlined />
								</a>
							);
						},
					},
					{
						title: 'Download PDF',
						align: 'center',
						render: (_, record) => {
							return (
								<a
									onClick={(e) => {
										e.preventDefault();
										openCallReportPDFModal({
											prospectId,
											callReportId: record.surveyCallReportId,
										});
									}}
								>
									<FilePdfOutlined />
								</a>
							);
						},
					},
				]}
			/>

			<CallReportAttendeeModal {...callReportAttendeeModal} />
		</Space>
	);
};

export default FRMCallReportHistoryPage;
